{
  "header": {
    "nameShowStaticText": false,
    "nameVariable": {
      "id": "5387d6e2-e822-40dd-b1e0-55e942bc8b81",
      "modelUri": "http://opcfoundation.org/UA/Woodworking/",
      "nodeId": "ns=1;i=6015",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "b6156853-a866-4573-80ad-e2492d1bf4d7",
      "modelUri": "http://opcfoundation.org/UA/Woodworking/",
      "nodeId": "ns=1;i=6019",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "defaultImagePathClassifierVariable": {
      "id": "cbbe196f-af44-4459-bad4-110c783da6dd",
      "modelUri": "http://opcfoundation.org/UA/Woodworking/",
      "nodeId": "ns=1;i=6018",
      "displayName": "DeviceClass",
      "variablePath": "Identification.DeviceClass",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "imageDefaults": {
      "BoringMachine": "BoringMachine.jpg",
      "EdgebandingMachine": "EdgebandingMachine.jpg",
      "HandlingMachine": "HandlingMachine.jpg",
      "MachiningCenter": "MachiningCenter.jpg",
      "Press": "Press.jpg",
      "ProfilingMachine": "ProfilingMachine.jpg",
      "SandingMachine": "SandingMachine.jpg",
      "SawingMachine": "SawingMachine.jpg",
      "[\\s\\S]*": "wood_throughfeed.jpg"
    }
  },
  "stacklight": {
    "colorVariable": {
      "id": "cdd5d018-ae08-49c8-b285-7f46ac5fdf28",
      "modelUri": "http://opcfoundation.org/UA/Woodworking/",
      "nodeId": "ns=1;i=6392",
      "displayName": "CurrentState",
      "variablePath": "State.Machine.Overview.CurrentState",
      "dataType": "Enum",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false,
      "enumValues": {
        "0": "OFFLINE",
        "1": "STANDBY",
        "2": "READY",
        "3": "WORKING",
        "4": "ERROR"
      }
    },
    "colorValues": {
      "OFFLINE": "off",
      "STANDBY": "grey",
      "READY": "yellow",
      "WORKING": "green",
      "ERROR": "red"
    }
  },
  "timeline": {
    "variable": {
      "id": "2db930e6-3dc8-41cd-b5c4-479455bd0c76",
      "modelUri": "http://opcfoundation.org/UA/Woodworking/",
      "nodeId": "ns=1;i=6381",
      "displayName": "RecipeInRun",
      "variablePath": "State.Machine.Flags.RecipeInRun",
      "dataType": "Boolean",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "colorValues": {
      "True": "#00b20e",
      "False": "#17a2b8"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "97029c5e-fdc1-43d7-a4f1-bf4dbea6b5a1",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6016",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "id": "5387d6e2-e822-40dd-b1e0-55e942bc8b81",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6015",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "47cc3538-5014-488f-81e1-c0e80e203863",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6017",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "showAsLink": false,
              "valueVariable": {
                "id": "0342d2c9-ddb5-4c65-b2a1-0117a1599699",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6029",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "showAsLink": false,
              "valueVariable": {
                "id": "da72b041-9b58-49c2-9571-7e912ea8e019",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6020",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "showAsLink": false,
              "valueVariable": {
                "id": "cbbe196f-af44-4459-bad4-110c783da6dd",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6018",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "showAsLink": false,
              "valueVariable": {
                "id": "b4ab44d3-1b02-4474-932b-81bf77e9bfa5",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6025",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "b6156853-a866-4573-80ad-e2492d1bf4d7",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6019",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "77d719d3-aece-437a-9136-119705e51b8f",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6028",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Mode",
              "valueVariable": {
                "id": "28537829-50fa-4ae0-9119-873b83b43681",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6393",
                "displayName": "CurrentMode",
                "variablePath": "State.Machine.Overview.CurrentMode",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "AUTOMATIC",
                  "2": "SEMIAUTOMATIC",
                  "3": "MANUAL",
                  "4": "SETUP",
                  "5": "SLEEP"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine State",
              "valueVariable": {
                "id": "cdd5d018-ae08-49c8-b285-7f46ac5fdf28",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6392",
                "displayName": "CurrentState",
                "variablePath": "State.Machine.Overview.CurrentState",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OFFLINE",
                  "1": "STANDBY",
                  "2": "READY",
                  "3": "WORKING",
                  "4": "ERROR"
                }
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Feed Speed",
              "valueVariable": {
                "id": "2e195d26-421a-43bc-ba1e-1bccc18327eb",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6400",
                "displayName": "FeedSpeed",
                "variablePath": "State.Machine.Values.FeedSpeed",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              },
              "customRangeHigh": 60,
              "condition": {
                "valueVariable": {
                  "id": "cbbe196f-af44-4459-bad4-110c783da6dd",
                  "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                  "nodeId": "ns=1;i=6018",
                  "displayName": "DeviceClass",
                  "variablePath": "Identification.DeviceClass",
                  "dataType": "String",
                  "valueRank": -1,
                  "modellingRule": "Mandatory",
                  "hasProperties": false
                },
                "values": [
                  "ProfilingMachine",
                  "EdgebandingMachine",
                  "BoringMachine",
                  "SandingMachine",
                  "HandlingMachine"
                ]
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Axis Override",
              "valueVariable": {
                "id": "d748fa19-eece-4175-97d8-3f7a121127c4",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6398",
                "displayName": "AxisOverride",
                "variablePath": "State.Machine.Values.AxisOverride",
                "dataType": "UInt32",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              },
              "customRangeHigh": 100,
              "condition": {
                "valueVariable": {
                  "id": "cbbe196f-af44-4459-bad4-110c783da6dd",
                  "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                  "nodeId": "ns=1;i=6018",
                  "displayName": "DeviceClass",
                  "variablePath": "Identification.DeviceClass",
                  "dataType": "String",
                  "valueRank": -1,
                  "modellingRule": "Mandatory",
                  "hasProperties": false
                },
                "values": ["SawingMachine", "MachiningCenter", "Press"]
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Pieces in",
              "showAsLink": false,
              "valueVariable": {
                "id": "61ab68e3-7da7-43f1-a3c8-ba620614bcf6",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6375",
                "displayName": "WorkpiecePresent",
                "variablePath": "State.Machine.Flags.WorkpiecePresent",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Power persent",
              "showAsLink": false,
              "valueVariable": {
                "id": "827a6a8b-43bd-42fe-9a03-b8c16f34735b",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6368",
                "displayName": "PowerPresent",
                "variablePath": "State.Machine.Flags.PowerPresent",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Alarm",
              "showAsLink": false,
              "valueVariable": {
                "id": "50733571-c667-43b2-908f-11f7624c67d1",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6378",
                "displayName": "Alarm",
                "variablePath": "State.Machine.Flags.Alarm",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Air present",
              "showAsLink": false,
              "valueVariable": {
                "id": "a4ef8e67-7616-4bac-96ee-f151767eab14",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6369",
                "displayName": "AirPresent",
                "variablePath": "State.Machine.Flags.AirPresent",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Emergency",
              "showAsLink": false,
              "valueVariable": {
                "id": "a99d55bd-19d6-48a0-9cf9-9d39572d2015",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6371",
                "displayName": "Emergency",
                "variablePath": "State.Machine.Flags.Emergency",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Calibrated",
              "showAsLink": false,
              "valueVariable": {
                "id": "ac38fdb9-9ab8-4d32-a068-27be91b07dfd",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6373",
                "displayName": "Calibrated",
                "variablePath": "State.Machine.Flags.Calibrated",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Active Program",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "0342d2c9-ddb5-4c65-b2a1-0117a1599667",
                "modelUri": "http://opcfoundation.org/UA/Eumabois/",
                "nodeId": "ns=1;i=6020",
                "displayName": "LastProgramName",
                "variablePath": "ManufacturerSpecific.LastProgramName",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#eaeaea",
                  "value": "true",
                  "label": "Active"
                },
                {
                  "backgroundColor": "#eaeaea",
                  "textColor": "#343a40",
                  "value": "false",
                  "label": "Inactive"
                }
              ],
              "valueVariable": {
                "id": "2db930e6-3dc8-41cd-b5c4-479455bd0c76",
                "modelUri": "http://opcfoundation.org/UA/Woodworking/",
                "nodeId": "ns=1;i=6381",
                "displayName": "RecipeInRun",
                "variablePath": "State.Machine.Flags.RecipeInRun",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    }
  ]
}
